import React, { useState } from 'react';
import './styles.css';

import { BiMap } from 'react-icons/bi';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import Fade from '@material-ui/core/Fade';
import SelectLocOnMap from './SelectLocOnMap';

import Moment from 'react-moment';
import { FaTrashAlt } from 'react-icons/fa';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { IconButton } from '@material-ui/core';
import ConfirmDialog from '../../components/Notification/ConfirmDialog';
import { useNavigate } from 'react-router-dom';
import UserPermission from '../../components/UserPermission';
import { formatPhoneNumber } from '../utils/formatPhoneNumber';
import { green, red } from '@material-ui/core/colors';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const classes = {
  root: {
    display: 'flex',
  },
  modal: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '90%',
    height: '90%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    backgroundColor: 'white',
    padding: 20,
    overflow: 'auto',
  },
  /* Estilização do conteúdo dentro do container */
  paper: {
    padding: 16,
    display: 'inline-block',
    width: '100%',
    overflow: 'auto',
    flexDirection: 'row',
    minWidth: 'calc(100%)',
    marginRigth: '20px',
    backgroundColor: '#F5F5F5',
  },

  /* Estilização do títutlo */
  textTitle: {
    color: '#103168',
    fontWeight: 600,
    textAlign: 'center',
    marginBottom: 20,
  },
  textDescription: {
    margin: 8,
    color: 'rgba(0, 0, 0, 0.54)',
    fontFamily: 'Rawline',
  },

  buttonImage: {
    color: '#155BCB',
    fontFamily: 'Rawline',
    padding: 0,
  },
  message: {
    padding: 10,
    backgroundColor: '#FFFBE8',
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%',
    fontFamily: 'Rawline',
  },
  classificationTag: {
    backgroundColor: '#155BCB',
    color: 'white',
    padding: '4px 8px',
    borderRadius: '4px',
    marginLeft: '8px',
    display: 'inline-block',
  },
  buttonSubmit: {
    backgroundColor: '#155BCB',
    color: '#fff',
    margin: '20px 0',
    '&:hover': {
      backgroundColor: '#103168',
    },
  },
  buttonContainer: {
    display: 'flex',
    gap: '10px',
    marginTop: '8px',
  },
  buttonGreen: {
    backgroundColor: green[600],
    color: '#fff',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: green[800],
    },
  },
  buttonRed: {
    backgroundColor: red[600],
    color: '#fff',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: red[800],
    },
  },
};

export default function DetailsComplaint({
  complaint,
  nameExecutor,
  classification,
  originalArea,
  isLoading,
}) {
  const userPermission = UserPermission();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const navigate = useNavigate();

  const deleteComplaint = () => {
    setConfirmDialog({
      isOpen: true,
      title: 'Você tem certeza que quer deletar a ocorrência?',
      subTitle: 'Não será possível reverter esta ação',
      onConfirm: () => confirmDelete(complaint[0].id),
    });
  };

  const confirmDelete = (id) => {
    api
      .delete(`admin/complaints/${id}`)
      .then((re) => {
        toast.success('Ocorrência Deletada com sucesso');
        navigate(-1);
      })
      .catch((r) => {
        const message = r.response?.data?.error?.message;
        toast.error(message || 'Erro desconhecido');
      });
  };

  const handleAreaUpdate = async (selectedArea) => {
    try {
      await api.put(`admin/complaints/${complaint[0].id}/area`, {
        area: selectedArea,
      });
      toast.success('Área atualizada com sucesso');
      window.location.reload();
    } catch (error) {
      const message = error.response?.data?.error?.message;
      toast.error(message || 'Erro ao atualizar área');
    }
  };

  const handleAssumeComplaint = async () => {
    try {
      await api.put(`${userPermission}/complaints/${complaint[0].id}/assume`);
      toast.success('Ocorrência assumida com sucesso');
      window.location.reload();
    } catch (error) {
      const message = error.response?.data?.error?.message;
      toast.error(message || 'Erro ao assumir ocorrência');
    }
  };

  return (
    <Paper style={classes.paper} elevation={1}>
      <div className="information-complaints">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr' }}>
          <div></div>
          <Typography variant="h6" align="center" style={classes.textTitle}>
            Informações da Ocorrência
          </Typography>

          {userPermission === 'admin' ? (
            <div style={{ width: '100%', textAlign: 'right' }}>
              <IconButton onClick={deleteComplaint}>
                <FaTrashAlt color="grey" />
              </IconButton>
            </div>
          ) : (
            false
          )}
        </div>

        <div style={classes.message}>
          Abaixo é possível visualizar informações acerca da ocorrência
          registrada.
        </div>

        <ul>
          {complaint.map((data) => (
            <li key={data.id}>
              <strong>
                CÓDIGO:
                <span>{data.reference}</span>
              </strong>

              <strong>
                STATUS:
                <span
                  className = {
                    data.status === 'Em análise'
                      ? 'analise'
                      : data.status === 'Resolvido'
                      ? 'resolvido'
                      : data.status === 'Indeferido'
                      ? 'indeferido'
                      : data.status === 'Notificado'
                      ? 'notificado'
                      : data.status === 'Novo'
                      ? 'novo'
                      : 'sem-cor'
                  }
                >
                  {data.status}
                </span>
              </strong>

              <strong>
                GRUPO:
                <span>{data?.group || 'Não informado'}</span>
              </strong>

              <strong>
                ÁREA:
                <span>{data.area}</span>
                {isLoading ? (
                  <span style={classes.classificationTag}>
                    <AutoAwesomeIcon style={{ marginRight: '4px' }} />
                    Carregando...
                  </span>
                ) : (
                  classification &&
                  classification !== 'Outros' &&
                  data.area !== classification &&
                  !originalArea && (
                    <span
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        marginLeft: '8px',
                      }}
                    >
                      <span style={classes.classificationTag}>
                        <AutoAwesomeIcon style={{ marginRight: '4px' }} />
                        {classification}
                      </span>
                      <Button
                        style={{
                          ...classes.buttonGreen,
                          margin: '0 4px',
                        }}
                        variant="contained"
                        startIcon={<CheckIcon style={{ color: '#fff' }} />}
                        onClick={() => handleAreaUpdate(classification)}
                      ></Button>

                      <Button
                        style={{
                          ...classes.buttonRed,
                          margin: '0 4px',
                        }}
                        variant="contained"
                        startIcon={<CloseIcon style={{ color: '#fff' }} />}
                        onClick={() => handleAreaUpdate(data.area)}
                      ></Button>
                    </span>
                  )
                )}
              </strong>

              <strong>
                DATA DA CRIAÇÃO:
                <span>
                  <Moment locale format={'DD/MM/YYYY HH:mm'}>
                    {data.createdAt}
                  </Moment>
                </span>
              </strong>

              {data.anonymous === false && (
                <>
                  <strong>
                    TELEFONE:
                    <span>{formatPhoneNumber(data.userPhone)}</span>
                  </strong>

                  <strong>
                    NOME DO CIDADÃO:
                    <span>{data.username}</span>
                  </strong>
                </>
              )}

              <strong>
                DATA DA ÚLTIMA ATUALIZAÇÃO:
                <span>
                  <Moment locale format={'DD/MM/YYYY HH:mm'}>
                    {data.updatedAt}
                  </Moment>
                </span>
              </strong>

              <strong>
                TEMPO MÉDIO DE ATENDIMENTO:
                <span>{data.timePrevision} dias</span>
              </strong>

              <strong>
                DATA PREVISTA DE ATENDIMENTO:
                <span>
                  <Moment locale format={'DD/MM/YYYY HH:mm'}>
                    {data.datePrevision}
                  </Moment>
                </span>
              </strong>

              {data.status === 'Resolvido' ? (
                <strong>
                  DATA DE RESOLUÇÃO:
                  <span>
                    <Moment locale format={'DD/MM/YYYY HH:mm'}>
                      {data.updatedAt}
                    </Moment>
                  </span>
                </strong>
              ) : (
                false
              )}

              <strong>
                RUA:
                <span>
                  {data.address === '' ? 'Não informado' : data.address}
                </span>
              </strong>

              <strong>
                BAIRRO:
                <span>
                  {data.neighborhood === ''
                    ? 'Não informado'
                    : data.neighborhood}
                </span>
              </strong>

              <strong>
                PONTO DE REFERÊNCIA:
                <span>
                  {data.referencePoint === ''
                    ? 'Não informado'
                    : data.referencePoint}
                </span>
              </strong>

              <strong>
                EXECUTOR RESPONSÁVEL:
                <span>
                  {'executorId' in data
                    ? nameExecutor
                    : 'Sem executor atribuído'}
                </span>
              </strong>

              <strong>
                HOMOLOGADO:
                <span>{data.validationControl === false ? 'Não' : 'Sim'}</span>
              </strong>

              <strong>
                CONTROLADOR RESPONSÁVEL:
                <span>{data.controladorName || 'Sem controlador atribuído'}</span>
              </strong>

              <strong>
                ETAPA DOS STATUS:
                <span>{data.statusStep}</span>
              </strong>

              {data.latitude !== 0 && data.longitute !== 0 ? (
                <CardActions style={classes.buttonImage}>
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${data.latitude},${data.longitute}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <Button
                      style={classes.buttonImage}
                      startIcon={
                        <BiMap size={25} style={{ color: '#155BCB' }} />
                      }
                    >
                      Visualizar no mapa
                    </Button>
                  </a>
                </CardActions>
              ) : (
                <CardActions style={classes.buttonImage}>
                  <Button
                    style={classes.buttonImage}
                    onClick={handleOpen}
                    startIcon={<BiMap size={25} style={{ color: '#155BCB' }} />}
                  >
                    Selecionar localização
                  </Button>

                  <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropProps={{
                      timeout: 500,
                    }}
                  >
                    <Fade in={open}>
                      <Box style={classes.modal}>
                        <SelectLocOnMap setOpen={setOpen} occurrence={data} />
                      </Box>
                    </Fade>
                  </Modal>
                </CardActions>
              )}

              {userPermission === 'manager' &&
                !data.controladorName && (
                  <div style={{ marginTop: 12 }}>
                    <Button
                      style={{ ...classes.buttonSubmit, color: '#fff', margin: 0 }}
                      variant="contained"
                      onClick={handleAssumeComplaint}
                    >
                      Assumir Ocorrência
                    </Button>
                  </div>
                )}
            </li>
          ))}
        </ul>
      </div>

      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={setConfirmDialog}
      />
    </Paper>
  );
}
